import Hero from "../components/Hero";
import NextLevel from "../components/NextLevel";
import CoachingInfo from "../components/CoachingInfo";
import Schedule from "../components/Schedule";
import Benefits from "../components/Benifits";

export default function Home() {
  return (
    <>
      <Hero />
      <NextLevel />
      <CoachingInfo />
      <Schedule />
      <Benefits />
    </>
  );
}
